import React, { useEffect, useRef } from "react";
import { TRANSITIONS } from "../utils/transitions";

export default function TransitionPreviewCanvas({ transition, imgA, imgB }) {
  const canvasRef = useRef(null);
  const rafRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    let start = null;
    const duration = 1000; // 1s preview loop

    const animate = (timestamp) => {
      if (!start) start = timestamp;
      let t = (timestamp - start) % duration;
      let p = t / duration;

      ctx.clearRect(0, 0, canvas.width, canvas.height);

      const fn = TRANSITIONS[transition] || TRANSITIONS["fade"];
      fn(ctx, imgA, imgB, p, canvas);

      rafRef.current = requestAnimationFrame(animate);
    };

    rafRef.current = requestAnimationFrame(animate);

    return () => cancelAnimationFrame(rafRef.current);
  }, [transition, imgA, imgB]);

return (
  <canvas
    ref={canvasRef}
    width={80}
    height={45}
    className="
      rounded
      border border-gray-300 dark:border-gray-700
      bg-black
    "
  />
);

}
